import {useGenericQuery} from "../api/reactQuery";
import {getComments, addComment, likeComment} from "../queries/comments";
import {useCommentsStore} from "../stores/commentsStore";

function useComment(targetId: string) {
    const { setComments } = useCommentsStore()

    const {
        data,
        isError,
        error,
        isSuccess,
        isPending
    } = useGenericQuery(['comments', targetId], () => getComments(targetId), setComments);

    return {
        data,
        isError,
        isLoading: isPending,
        error,
        isSuccess,
        addComment,
        likeComment
    }
}

export default useComment;
